// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export const getSelectedValues = selected => {
  if (selected === undefined) {
    return [];
  }
  if (Array.isArray(selected)) {
    return selected;
  }
  return [selected];
};